<template>
<!--    <b-modal-->
<!--            title="Modification d'élément"-->
<!--            size="xl"-->
<!--            :modal-class="'base-modal middle-size'"-->
<!--            centered-->
<!--            ref="editElementModal"-->
<!--            :no-close-on-backdrop="true"-->
<!--            :no-close-on-esc="true"-->
<!--            :lazy="true"-->
<!--            @hide="close"-->
<!--    >-->
    <b-container fluid class="rightsidebar">
        <div class="row">
            <div class="col-3 content-editor enlarge">
    <!--                    <div :class="{'disabled-action': disabled}">-->
                <div>
                    <div class="btn-toolbar">
                        <b-button-group>
                            <b-dropdown
                                    :style="[
                                        {
                                          fontFamily: this.getSelectedFontFamily().family,
                                          fontSize: '12px',
                                          textOverflow: 'ellipsis'
                                        }
                                      ]"
                                    variant="outline-primary"
                                    class="font-type disabled-action"
                            >
                                <template slot="button-content">
                                    {{ this.getSelectedFontFamily().name | truncate(10) }}
                                </template>
                                <b-dropdown-item
                                        v-for="fm in this.fontFamily"
                                        :key="fm.name"
                                        :active="fm.state"
                                        :style="[{ fontFamily: fm.family, fontSize: '11px' }]"
                                        @click.prevent="fontFamilyClick(fm.family)"
                                >{{ fm.name }}</b-dropdown-item
                                >
                            </b-dropdown>
                            <b-dropdown
                                    :text="this.getSelectedFontSize()"
                                    variant="outline-primary"
                                    class="font-size disabled-action"
                            >
                                <b-dropdown-item
                                        v-for="size in this.fontSize"
                                        :key="size.value"
                                        :active="size.state"
                                        :style="[{ fontFamily: 'Arial', fontSize: '11px' }]"
                                        @click.prevent="fontSizeSelected(size.value)"
                                >{{ size.value }}</b-dropdown-item
                                >
                            </b-dropdown>
                        </b-button-group>
                        <b-button-group class="disabled-action">
                            <b-button
                                    :pressed="this.fontWeight.state"
                                    @click.prevent="fontWeightClick()"
                                    class="icon-btn"
                                    variant="outline-primary"
                            >
                                <font-awesome-icon :icon="['fas', 'bold']" />
                            </b-button>
                            <b-button
                                    :pressed="this.fontStyle.state"
                                    @click.prevent="fontStyleClick()"
                                    class="icon-btn"
                                    variant="outline-primary"
                            >
                                <font-awesome-icon :icon="['fas', 'italic']" />
                            </b-button>
                        </b-button-group>
                        <b-button-group>
                            <b-dropdown
                                    id="font-color-picker"
                                    class="icon-btn"
                                    variant="outline-primary"
                            >
                                <template slot="button-content">
                                    <font-awesome-icon v-bind:style="{ color }" :icon="['fas', 'font']" />
                                </template>
                                <div class="color-picker">
                                    <color-picker
                                            theme="light"
                                            :colors-default="societyColors"
                                            :colors-history-key="colorsHistoryKey"
                                            v-if="showFontColorPicker"
                                            :sucker-hide="true"
                                            :color="color"
                                            @changeColor="changeColor"
                                    />
                                </div>
                            </b-dropdown>
                            <b-dropdown
                                    id="background-color-picker"
                                    class="icon-btn"
                                    variant="outline-primary"
                            >
                                <template slot="button-content">
                                    <font-awesome-icon
                                            class="myBgColor"
                                            v-bind:style="{'--bgImage': backgroundColor}"
                                            :icon="['fas', 'fill-drip']"
                                    />
                                </template>
                                <div class="color-picker">
                                    <color-picker
                                            v-if="showBackgroundColorPicker"
                                            :sucker-hide="true"
                                            :color="backgroundColor"
                                            theme="light"
                                            :colors-default="societyColors"
                                            :colors-history-key="colorsHistoryKey"
                                            @changeColor="changeBackgroundColor"
                                    />
                                </div>
                            </b-dropdown>
                        </b-button-group>
                        <b-button-group class=" disabled-action">
                            <b-button
                                    v-for="align in this.justifyContent"
                                    :key="align.type"
                                    @click.stop="textAlignClick(align.type)"
                                    :pressed="align.state"
                                    class="icon-btn"
                                    variant="outline-primary"
                            >
                                <font-awesome-icon :icon="['fas', align.icon]" />
                            </b-button>
                        </b-button-group>
    <!--                            <b-button-->
    <!--                                    v-if="!this.showMore"-->
    <!--                                    @click.prevent="() => showMore = !showMore"-->
    <!--                                    class="icon-btn"-->
    <!--                                    variant="outline-primary"-->
    <!--                            >-->
    <!--                                Espacements-->
    <!--                            </b-button>-->
                    </div>
                </div>
                <edit-element-drop
                        v-if="this.active && this.element && this.element.type === 'drop'"
                        :data="element"
                        @dropEdit="handleDropEdit"
                        @columnChange="handleColumnChange"
                        @valueChange="handleValueChange"
                        @deleteData="handleDeleteData"
                />
                <edit-element-text
                        v-else-if="this.active && this.element && this.element.type === 'text'"
                        :data="element"
                        @textEdit="handleTextEdit"
                />
            </div>

            <!-- Begin Border styles -->
            <div class="col-3 content-editor disabled-action" id="borders-style" v-on-clickaway="handleClickOutside">

                <!-- Display all border types in a loop -->
                <ul class="borders text-center border-types" style="margin-bottom:10px;">
                    <li v-for="border in borders" :id="border.type" :class="border.type" :key="border.type" @click="selectBorder($event, border)"
                        :pressed="borderPosition.includes(border.type)">
                        <span>
                            <icon-base
                                    style="margin-bottom: 0;"
                                    :icon-name="border.icon"
                                    width="24"
                                    height="24"
                            />
                        </span>
                    </li>
                </ul>
                <!-- End border types -->

                <ul class="borders text-center" style="border-bottom:none;margin-bottom: 0;">
                    <li>
                        <div class="option-field" style="width:102px;">
                            <div class="multi-input">
                                <b-input-group size="sm" style="width: 100px">
                                    <template v-slot:prepend>
                                        <b-input-group-text>
                                            <icon-base
                                                    style="margin-bottom: 0;    padding-top: 0;"
                                                    icon-name="line-weight"
                                                    width="18"
                                                    height="18"
                                            />
                                        </b-input-group-text>
                                    </template>
                                    <b-form-input
                                            min="0"
                                            type="number"
                                            @blur="setBorderSize"
                                            @keyup="setBorderSize"
                                            oninput="validity.valid||(value='');"
                                            v-model="bdWidth"
                                    ></b-form-input>
                                    <template v-slot:append>
                                        <b-input-group-text>
                                    <span class="px">
                                        px
                                    </span>
                                        </b-input-group-text>
                                    </template>
                                </b-input-group>
                            </div>
                        </div>
                    </li>
                    <li>
                        <a nohref style="margin-left:5px;"
                           v-b-toggle.border-color
                        >
                            <icon-base
                                    style="margin-bottom: 0;"
                                    :style="{ color: borderColor, 'margin-bottom': 0 }"
                                    icon-name="border-color"
                                    width="18"
                                    height="18"
                            />
                        </a>
                    </li>
                </ul>

                <b-collapse id="border-color">
                    <div class="flex-container d-flex flex-column py-2">
                        <div class="color-picker">
                            <div class="color-picker">
                                <color-picker
                                        theme="light"
                                        :colors-default="societyColors"
                                        :colors-history-key="colorsHistoryKey"
                                        v-if="showBorderColorPicker"
                                        :sucker-hide="true"
                                        :color="borderColor"
                                        @changeColor="changeBorderColor"
                                />
                            </div>
                        </div>
                    </div>
                </b-collapse>
            </div>
            <!-- End border styles -->

            <!-- Begin Padding and margin -->
            <div class="col-4 content-editor  disabled-action" id="padding-and-margin" style="border-right:none;">

                <ul class="spacing" style="border-bottom:none;">
                    <li>Int.</li>
                    <li>
                        <div class="option-field" style="width:75px;">
                            <div class="multi-input">
                                <b-input-group size="sm">
                                    <template v-slot:prepend>
                                        <b-input-group-text>
                                            <strong>&#8593;</strong>
                                        </b-input-group-text>
                                    </template>
                                    <b-form-input
                                            min="0"
                                            type="number"
                                            v-model="paddingTop"
                                            @blur="setPaddingTop()"
                                            oninput="validity.valid||(value='');"
                                    ></b-form-input>
                                </b-input-group>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="option-field" style="width:75px;">
                            <div class="multi-input">
                                <b-input-group size="sm">
                                    <template v-slot:prepend>
                                        <b-input-group-text>
                                            <strong>&#8595;</strong>
                                        </b-input-group-text>
                                    </template>
                                    <b-form-input
                                            min="0"
                                            type="number"
                                            v-model="paddingBottom"
                                            @blur="setPaddingBottom()"
                                            oninput="validity.valid||(value='');"
                                    ></b-form-input>
                                </b-input-group>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="option-field" style="width:75px;">
                            <div class="multi-input">
                                <b-input-group size="sm">
                                    <template v-slot:prepend>
                                        <b-input-group-text>
                                            <strong>&#8592;</strong>
                                        </b-input-group-text>
                                    </template>
                                    <b-form-input
                                            min="0"
                                            type="number"
                                            v-model="paddingLeft"
                                            @blur="setPaddingLeft()"
                                            oninput="validity.valid||(value='');"
                                    ></b-form-input>
                                </b-input-group>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="option-field" style="width:75px;">
                            <div class="multi-input">
                                <b-input-group size="sm">
                                    <template v-slot:prepend>
                                        <b-input-group-text>
                                            <strong>&#8594;</strong>
                                        </b-input-group-text>
                                    </template>
                                    <b-form-input
                                            min="0"
                                            type="number"
                                            v-model="paddingRight"
                                            @blur="setPaddingRight()"
                                            oninput="validity.valid||(value='');"
                                    ></b-form-input>
                                </b-input-group>
                            </div>
                        </div>
                    </li>
                </ul>

                <ul class="spacing" style="border-bottom:none;margin-bottom: 0;">
                    <li>Ext.</li>
                    <li>
                        <div class="option-field" style="width:75px;">
                            <div class="multi-input">
                                <b-input-group size="sm">
                                    <template v-slot:prepend>
                                        <b-input-group-text>
                                            <strong>&#8593;</strong>
                                        </b-input-group-text>
                                    </template>
                                    <b-form-input
                                            min="0"
                                            type="number"
                                            v-model="marginTop"
                                            @blur="setMarginTop()"
                                            oninput="validity.valid||(value='');"
                                    ></b-form-input>
                                </b-input-group>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="option-field" style="width:75px;">
                            <div class="multi-input">
                                <b-input-group size="sm">
                                    <template v-slot:prepend>
                                        <b-input-group-text>
                                            <strong>&#8595;</strong>
                                        </b-input-group-text>
                                    </template>
                                    <b-form-input
                                            min="0"
                                            type="number"
                                            v-model="marginBottom"
                                            @blur="setMarginBottom()"
                                            oninput="validity.valid||(value='');"
                                    ></b-form-input>
                                </b-input-group>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="option-field" style="width:75px;">
                            <div class="multi-input">
                                <b-input-group size="sm">
                                    <template v-slot:prepend>
                                        <b-input-group-text>
                                            <strong>&#8592;</strong>
                                        </b-input-group-text>
                                    </template>
                                    <b-form-input
                                            min="0"
                                            type="number"
                                            v-model="marginLeft"
                                            @blur="setMarginLeft()"
                                            oninput="validity.valid||(value='');"
                                    ></b-form-input>
                                </b-input-group>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="option-field" style="width:75px;">
                            <div class="multi-input">
                                <b-input-group size="sm">
                                    <template v-slot:prepend>
                                        <b-input-group-text>
                                            <strong>&#8594;</strong>
                                        </b-input-group-text>
                                    </template>
                                    <b-form-input
                                            min="0"
                                            type="number"
                                            v-model="marginRight"
                                            @blur="setMarginRight()"
                                            oninput="validity.valid||(value='');"
                                    ></b-form-input>
                                </b-input-group>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <!-- End padding and margin -->

            <transition name="slide-fade">
                <div v-if="this.showMore" class="col-6 px-0" style="height: 550px; overflow-y: auto;">
                    <div class="btn-toolbar float-right">
                        <b-button
                                @click.prevent="() => showMore = !showMore"
                                class="icon-btn"
                                variant="outline-danger"
                        >
                            Fermer
                        </b-button>
                    </div>
                    <ul class="wrapper-setting px-0">
<!--                        <li v-if="this.element.type !== 'drop'" class="setting-option">-->
<!--                            <div class="option-details">-->
<!--                                <h3>Espacement intérieurs (padding)</h3>-->
<!--                                <p class="description">-->
<!--                                    Modifie les espacements intérieurs (en haut, à droite, en bas et à gauche) de l'élément. Exprimé en pixels.-->
<!--                                </p>-->
<!--                            </div>-->
<!--                            <div class="option-field">-->
<!--                                <div class="multi-input">-->
<!--                                    <b-input-group class="mb-2" size="sm" style="width: 100px">-->
<!--                                        <template v-slot:prepend>-->
<!--                                            <b-input-group-text><font-awesome-icon :icon="['fas', 'arrow-up']" /></b-input-group-text>-->
<!--                                        </template>-->
<!--                                        <b-form-input min="0"-->
<!--                                                      type="number"-->
<!--                                                      :value="paddingTop"-->
<!--                                                      @change="(value) => updateStyle('paddingTop', value, 'px')"-->
<!--                                        ></b-form-input>-->
<!--                                    </b-input-group>-->
<!--                                    <b-input-group class="mb-2" size="sm" style="width: 100px">-->
<!--                                        <template v-slot:prepend>-->
<!--                                            <b-input-group-text><font-awesome-icon :icon="['fas', 'arrow-right']" /></b-input-group-text>-->
<!--                                        </template>-->
<!--                                        <b-form-input min="0"-->
<!--                                                      type="number"-->
<!--                                                      :value="paddingRight"-->
<!--                                                      @change="(value) => updateStyle('paddingRight', value, 'px')"-->
<!--                                        ></b-form-input>-->
<!--                                    </b-input-group>-->
<!--                                    <b-input-group class="mb-2" size="sm" style="width: 100px">-->
<!--                                        <template v-slot:prepend>-->
<!--                                            <b-input-group-text><font-awesome-icon :icon="['fas', 'arrow-down']" /></b-input-group-text>-->
<!--                                        </template>-->
<!--                                        <b-form-input min="0"-->
<!--                                                      type="number"-->
<!--                                                      :value="paddingBottom"-->
<!--                                                      @change="(value) => updateStyle('paddingBottom', value, 'px')"-->
<!--                                        ></b-form-input>-->
<!--                                    </b-input-group>-->
<!--                                    <b-input-group class="mb-2" size="sm" style="width: 100px">-->
<!--                                        <template v-slot:prepend>-->
<!--                                            <b-input-group-text><font-awesome-icon :icon="['fas', 'arrow-left']" /></b-input-group-text>-->
<!--                                        </template>-->
<!--                                        <b-form-input min="0"-->
<!--                                                      type="number"-->
<!--                                                      :value="paddingLeft"-->
<!--                                                      @change="(value) => updateStyle('paddingLeft', value, 'px')"-->
<!--                                        ></b-form-input>-->
<!--                                    </b-input-group>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </li>-->
    <!--                            <li class="setting-option">-->
    <!--                                <div class="option-details">-->
    <!--                                    <h3>Espacement extérieurs</h3>-->
    <!--                                    <p class="description">-->
    <!--                                        Modifie les espacements extérieurs (en haut et en bas) de l'élément. Exprimé en pixels.-->
    <!--                                    </p>-->
    <!--                                </div>-->
    <!--                                <div class="option-field">-->
    <!--                                    <div class="multi-input">-->
    <!--                                        <b-input-group class="mb-2" size="sm" style="width: 100px">-->
    <!--                                            <template v-slot:prepend>-->
    <!--                                                <b-input-group-text><font-awesome-icon :icon="['fas', 'arrow-up']" /></b-input-group-text>-->
    <!--                                            </template>-->
    <!--                                            <b-form-input min="0"-->
    <!--                                                          type="number"-->
    <!--                                                          :value="marginTop"-->
    <!--                                                          @change="(value) => updateStyle('marginTop', value, 'px', true)"-->
    <!--                                            ></b-form-input>-->
    <!--                                        </b-input-group>-->
    <!--                                        <b-input-group class="mb-2" size="sm" style="width: 100px">-->
    <!--                                            <template v-slot:prepend>-->
    <!--                                                <b-input-group-text><font-awesome-icon :icon="['fas', 'arrow-right']" /></b-input-group-text>-->
    <!--                                            </template>-->
    <!--                                            <b-form-input min="0"-->
    <!--                                                          type="number"-->
    <!--                                                          :value="marginRight"-->
    <!--                                                          @change="(value) => updateStyle('marginRight', value, 'px', true)"-->
    <!--                                            ></b-form-input>-->
    <!--                                        </b-input-group>-->
    <!--                                        <b-input-group class="mb-2" size="sm" style="width: 100px">-->
    <!--                                            <template v-slot:prepend>-->
    <!--                                                <b-input-group-text><font-awesome-icon :icon="['fas', 'arrow-down']" /></b-input-group-text>-->
    <!--                                            </template>-->
    <!--                                            <b-form-input min="0"-->
    <!--                                                          type="number"-->
    <!--                                                          :value="marginBottom"-->
    <!--                                                          @change="(value) => updateStyle('marginBottom', value, 'px', true)"-->
    <!--                                            ></b-form-input>-->
    <!--                                        </b-input-group>-->
    <!--                                        <b-input-group class="mb-2" size="sm" style="width: 100px">-->
    <!--                                            <template v-slot:prepend>-->
    <!--                                                <b-input-group-text><font-awesome-icon :icon="['fas', 'arrow-left']" /></b-input-group-text>-->
    <!--                                            </template>-->
    <!--                                            <b-form-input min="0"-->
    <!--                                                          type="number"-->
    <!--                                                          :value="marginLeft"-->
    <!--                                                          @change="(value) => updateStyle('marginLeft', value, 'px', true)"-->
    <!--                                            ></b-form-input>-->
    <!--                                        </b-input-group>-->
    <!--                                    </div>-->
    <!--                                </div>-->
    <!--                            </li>-->
                    </ul>
                </div>
            </transition>
        </div>
    </b-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { fontSizes, defaultElementStyle } from '../../../config/constanteUse'
import colorPicker from '@caohenghu/vue-colorpicker'
import iconBase from '../../icons/iconBase'
import { directive as onClickaway } from 'vue-clickaway'
import axios from 'axios'
import { ENTRYPOINT } from '../../../config/entrypoint'
import {eventBus} from '../../../main'
// const {paddingTop, paddingRight, paddingBottom, paddingLeft, marginTop, marginBottom, marginLeft, marginRight} = defaultElementStyle
import { defaultWrapperStyle } from '../../../config/constanteUse'

export default {
  directives: {
    onClickaway: onClickaway
  },
  components: {
    colorPicker,
    iconBase
  },
  data () {
    return {
      ...defaultWrapperStyle,
      borderPosition: [],
      position: {
        '0': 'top',
        '1': 'right',
        '2': 'bottom',
        '3': 'left'
      },
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
      bdWidth: 1,
      wrapper: null,
      wrapperIndex: null,
      showColorPicker: false,
      showBorderColorPicker: false,
      showMore: false,
      element: {type: 'drop'},
      elindex: null,
      active: false,
      context: null,
      changedValue: [],
      deletedData: [],
      dropStyle: [],
      columnStyleArray: [],
      justifyContent: [
        { icon: 'align-left', type: 'left', state: false },
        { icon: 'align-center', type: 'center', state: false },
        { icon: 'align-right', type: 'right', state: false }
      ],
      fontStyle: {
        name: 'italic', state: false
      },
      fontWeight: {
        name: 'bold', state: false
      },
      fontFamily: [
        { name: 'Arial', family: 'Arial, Helvetica, sans-serif', state: true },
        { name: 'Arial Black', family: '"Arial Black", Gadget, sans-serif', state: false },
        { name: 'Impact', family: 'impactregular', state: false },
        { name: 'Comic Sans MS', family: '"Comic Sans MS", cursive, sans-serif', state: false },
        { name: 'Courier New', family: '"Courier New", Courier, monospace', state: false },
        { name: 'Georgia', family: 'Georgia, serif', state: false },
        { name: 'Lucida Console', family: '"Lucida Console", Monaco, monospace', state: false },
        { name: 'Lucida Sans Unicode', family: '"Lucida Sans Unicode", "Lucida Grande", sans-serif', state: false },
        { name: 'Open Sans', family: '"Open sans", Arial, sans-serif', state: false },
        { name: 'Palatino Linotype', family: '"Palatino Linotype", "Book Antiqua", Palatino, serif', state: false },
        { name: 'Tahoma', family: 'Tahoma, Geneva, sans-serif', state: false },
        { name: 'Times New Roman', family: '"Times New Roman", Times, serif', state: false },
        { name: 'Trebuchet MS', family: '"Trebuchet MS", Helvetica, sans-serif', state: false },
        { name: 'Verdana', family: 'Verdana, Geneva, sans-serif', state: false },
        { name: 'Corbel', family: 'Corbel', state: false },
        { name: 'Calibri', family: 'Calibri', state: false },
        { name: 'Lucida Sans', family: 'Lucida Sans', state: false },
        { name: 'Agency FB', family: 'Agency FB', state: false },
        { name: 'Berlin Sans FB', family: 'Berlin Sans FB', state: false },
        { name: 'Book Antiqua', family: 'Book Antiqua', state: false },
        { name: 'Century', family: 'Century', state: false },
        { name: 'Century Gothic', family: 'Century Gothic', state: false },
        { name: 'Bell MT', family: 'Bell MT', state: false },
        { name: 'Franklin Gothic Book', family: 'Franklin Gothic Book', state: false },
        { name: 'Candara', family: 'Candara', state: false },
        { name: 'Bookman Old Style', family: 'Bookman Old Style', state: false },
        { name: 'Impacted', family: 'Impacted', state: false },
        { name: 'Arial Narrow', family: 'Arial Narrow', state: false },
        { name: 'Gill Sans', family: 'Gill Sans', state: false },
        { name: 'Avenir Next LT Pro', family: 'Avenir Next LT Pro', state: false }
      ],
      borders: [
        {
          type: 'none', style: 'solid', icon: 'border-none'
        },
        {
          type: 'top', style: 'solid', icon: 'border-top'
        },
        {
          type: 'right', style: 'solid', icon: 'border-right'
        },
        {
          type: 'bottom', style: 'solid', icon: 'border-bottom'
        },
        {
          type: 'left', style: 'solid', icon: 'border-left'
        },
        {
          type: 'outer', style: 'solid', icon: 'border-outer'
        }
      ],
      fontSize: [],
      showFontColorPicker: false,
      showBackgroundColorPicker: false,
      color: '',
      backgroundColor: '',
      borderColor: '',
      isSelectingColor: false,
      colorPickerDelay: null,
      colorsHistoryKey: 'font-color-story',
      usedFontColor: null,
      myWrapperStyle: [],
      containerSelected: false,
      columnselected: false,
      containerIndex: null,
      columnIndex: null,
      contentSelected: false,
      index: null,
      colStyle: '',
      valStyle: '',
      type: null
    }
  },
  computed: {
    disabled () {
      if (this.element) {
        return (this.element.type === 'drop' && !this.context)
      }
      return false
    }
  },
  async created () {
    this.fontSize = fontSizes.map(size => {
      return {
        value: size,
        state: false
      }
    })

    // get font color history
    const userColors = await axios({ url: ENTRYPOINT + '/api/get-user-color-history', method: 'GET' })
    localStorage.setItem(this.colorsHistoryKey, JSON.stringify(userColors.data.font))

    this.colorsHistory = userColors.data.font
    this.societyColors = userColors.data.societyColors
  },
  mounted () {
    var $this = this
    eventBus.$on('enableToolbarButtons', () => {
      this.activateToolBarOptions()
    })

    eventBus.$on('disableToolbarButtons', () => {
      this.disableToolbarButtons()
      this.containerSelected = false
    })

    eventBus.$on('selected', (data) => {
      this.type = data.type
      if (data.type === 'content') {
        this.element = JSON.parse(JSON.stringify(data.element))
        this.myWrapperStyle = this.element.style

        this.containerIndex = data.conIndex
        this.columnIndex = data.colIndex
        this.elindex = data.elindex
        this.index = data.index
        this.context = data.context
        this.wrapper = null

        // document.querySelector('.columnActive').classList.add('temp-bloc-deselect')

        this.contentSelected = true
        this.columnselected = false
        this.containerSelected = false

        this.syncStateData(data)
      } else if (data.type === 'colonne') {
        // document.getElementById('conteneur-' + data.containerId).classList.add('columnSelectedClass')

        this.columnselected = true
        this.containerSelected = false
        this.contentSelected = false
        this.containerIndex = data.containerId
        this.columnIndex = data.columnIndex
        this.element = null
        this.wrapper = null

        if (document.querySelector('.columnActive')) {
          this.columnselected = true
        }

        if (document.querySelector('.temp-col-deselect') || document.querySelector('.temp-bloc-deselect')) {
          // this.columnselected = false
        } else {
          this.wrapper = JSON.parse(JSON.stringify(data.element))

          if (!this.wrapper.style) {
            this.wrapper.style = {}
          }

          this.syncStateData(data)
        }
      } else if (data.type === 'conteneur') {
        this.containerSelected = true
        this.columnselected = false
        this.contentSelected = false
        this.element = null
        this.wrapper = null
        this.wrapper = JSON.parse(JSON.stringify(data.elements[data.index]))
        this.wrapperIndex = data.index

        if (!this.wrapper.style) {
          this.wrapper.style = {}
        } else {
          if (this.wrapper.style.length > 0) {
            // Style were set, we select button on the toolbar.. Damn....
            this.borderColor = this.wrapper.style.borderColor
            this.backgroundColor = this.wrapper.style.backgroundColor
            this.bdWidth = this.getBorderSize(this.wrapper.style.borderWidth)
            this.borderPosition = this.getBorderPosition(this.wrapper.style.borderWidth)

            for (var i = 0; i < this.borderPosition.length; i++) {
              var pos = this.borderPosition[i]
              if (pos === 'all') {
                pos = 'outer'
              }

              document.querySelector('.' + pos).classList.add('active')
            }

            this.paddingTop = this.wrapper.style.paddingTop.replace(/px/g, '')
            this.paddingBottom = this.wrapper.style.paddingBottom.replace(/px/g, '')
            this.paddingRight = this.wrapper.style.paddingRight.replace(/px/g, '')
            this.paddingLeft = this.wrapper.style.paddingLeft.replace(/px/g, '')

            this.marginTop = this.wrapper.style.marginTop.replace(/px/g, '')
            this.marginBottom = this.wrapper.style.marginBottom.replace(/px/g, '')
            this.marginRight = this.wrapper.style.marginRight.replace(/px/g, '')
            this.marginLeft = this.wrapper.style.marginLeft.replace(/px/g, '')
          }
        }

        this.syncStateData(data)
      }
    })

    // if (this.contentSelected === false) {
    //     eventBus.$on('columnSelected', (data) => {
    //
    //     })
    // }
    //
    // if (this.columnselected === false && this.contentSelected === false) {
    //     eventBus.$on('containerSelected', (data) => {
    //
    //     })
    // }

    this.$root.$on('bv::dropdown::show', bvEvent => {
      const storeColors = this.$store.state.colors.colors
      const newSocietyColors = [...new Set([...storeColors, ...this.societyColors])]

      this.societyColors = newSocietyColors
      if (bvEvent.vueTarget.id === 'font-color-picker') {
        this.showFontColorPicker = true
      } else if (bvEvent.vueTarget.id === 'background-color-picker') {
        this.showBackgroundColorPicker = true
      }
      this.color = null
      this.backgroundColor = null
      if (this.colorsHistory.length > 0) {
        var colHistory = null
        this.usedFontColor = this.colorsHistory[0]
        if (this.containerSelected === false && this.columnselected === false && this.element.type === 'drop') {
          if (this.context === 'value') {
            // this.color = typeof this.element.childElements[this.index].valStyle !== 'undefined' ? this.element.childElements[this.index].valStyle.color : 'rgba(0,0,0,1)'
            // this.backgroundColor = typeof this.element.childElements[this.index].valStyle !== 'undefined' ? this.element.childElements[this.index].valStyle.backgroundColor : 'rgba(255,255,255,1)'
          } else {
            if (typeof this.element.childElements[this.index] !== 'undefined') {
              // this.color = typeof this.element.childElements[this.index].colStyle !== 'undefined' ? this.element.childElements[this.index].colStyle.color : 'rgba(0,0,0,1)'
              // this.backgroundColor = typeof this.element.childElements[this.index].colStyle !== 'undefined' ? this.element.childElements[this.index].colStyle.backgroundColor : 'rgba(255,255,255,1)'
            }
          }
        } else if (this.containerSelected || this.columnselected) {
          // this.backgroundColor = this.wrapper.style.backgroundColor ? this.wrapper.style.backgroundColor : ''
        } else {
          // this.color = typeof this.element.style !== 'undefined' && this.element.style.color ? this.element.style.color : 'rgba(0,0,0,1)'
          // this.backgroundColor = typeof this.element.style !== 'undefined' && this.element.style.backgroundColor ? this.element.style.backgroundColor : 'rgba(255,255,255,1)'
        }

        localStorage.setItem(this.colorsHistoryKey, JSON.stringify(this.colorsHistory))
      }
    })

    this.$root.$on('bv::dropdown::hide', bvEvent => {
      if (bvEvent.vueTarget.id === 'font-color-picker') {
        this.showFontColorPicker = false
      } else if (bvEvent.vueTarget.id === 'background-color-picker') {
        this.showBackgroundColorPicker = false
      }

      var color = $this.usedFontColor
      var payload = {
        color: color,
        type: 'font'
      }

      if ($this.usedFontColor) {
        $this.setUserColor(payload)
      }
    })

    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if (collapseId === 'border-color') {
        this.showBorderColorPicker = isJustShown
      }
    })
  },
  filters: {
    truncate: function (text, length) {
      return (text.length > length) ? text.substring(0, length) + ' ...' : text
    }
  },
  methods: {
    ...mapActions(['syncDataValue', 'setAddedToFiche', 'overwriteDroppedHeader', 'addDeletedHeader']),
    ...mapGetters(['droppedHeaders', 'isProjectTemplate']),
    disableToolbarButtons () {
      document.getElementById('background-color-picker').classList.add('disabled-action')
      document.getElementById('borders-style').classList.add('disabled-action')
      document.getElementById('padding-and-margin').classList.add('disabled-action')

      var toolbarButtons = document.querySelectorAll('.background-color-picker, .borders-style, .padding-and-margin')

      for (let i = 0; i < toolbarButtons.length; i++) {
        toolbarButtons[i].classList.add('disabled-action')
      }

      document.getElementById('top').classList.remove('active')
      document.getElementById('right').classList.remove('active')
      document.getElementById('bottom').classList.remove('active')
      document.getElementById('left').classList.remove('active')
      document.getElementById('outer').classList.remove('active')

      this.paddingTop = 0
      this.paddingRight = 0
      this.paddingBottom = 0
      this.paddingLeft = 0

      this.marginTop = 0
      this.marginRight = 0
      this.marginBottom = 0
      this.marginLeft = 0
    },
    activateToolBarOptions () {
      if (document.getElementById('background-color-picker')) {
        document.getElementById('background-color-picker').classList.remove('disabled-action')
      }

      if (document.getElementById('borders-style')) {
        document.getElementById('borders-style').classList.remove('disabled-action')
      }

      if (document.getElementById('padding-and-margin')) {
        document.getElementById('padding-and-margin').classList.remove('disabled-action')
      }
    },
    setPadding (position) {
      // this.getAllAppliedStyle()
    },
    getBorderSize (size) {
      if (!size) {
        return 0
      }
      const sizes = size.split(' ')
      let res = 0
      sizes
        .map(sz => {
          if (sz.endsWith('px')) {
            return Number(sz.replace('px', ''))
          }
          return Number(sz)
        })
        .some(el => {
          if (el) {
            res = el
            return true
          } else {
            return false
          }
        })

      return res
    },
    getBorderPosition (size) {
      if (!size) {
        return ['all']
      }
      const sizes = size.split(' ')
      let res = ['all']

      const fsizes = sizes
        .map(sz => {
          if (sz.endsWith('px')) {
            return Number(sz.replace('px', ''))
          }
          return Number(sz)
        })

      if (fsizes.every(el => el > 0)) {
        return res
      }

      fsizes.forEach((el, index) => {
        if (el) {
          res.push(this.position[`${index}`])
        }
      })

      if (res.length > 1) {
        res.shift()
      }

      return res
    },
    async setUserColor (payload) {
      if (payload.color) {
        const resp = await axios({ url: ENTRYPOINT + '/api/set-user-color', data: payload, method: 'POST' })

        this.colorsHistory = resp.data.font
        this.bgHistory = resp.data.bg
        this.borderHistory = resp.data.border

        this.usedFontColor = null

        localStorage.setItem(this.colorsHistoryKey, JSON.stringify(resp.data.font))
      }
    },
    applyBorderPosition (position, size) {
      let res
      /* switch (position) {
              case 'all':
                res = `${size}px ${size}px ${size}px ${size}px`
                break
              case 'top':
                res = `${size}px 0 0 0`
                break
              case 'right':
                res = `0 ${size}px 0 0`
                break
              case 'bottom':
                res = `0 0 ${size}px 0`
                break
              case 'left':
                res = `0 0 0 ${size}px`
                break
            } */
      if (position.includes('all')) {
        res = `${size}px ${size}px ${size}px ${size}px`
      } else {
        let mapped = {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        }
        res = Object.values(position
          .reduce((acc, curr) => {
            acc[curr] = `${size}px`
            return acc
          }, mapped))
          .join(' ')
      }

      console.log(position.includes('none'))
      if (position.includes('none')) {
        res = `0px 0px 0px 0px`
      }

      return res
    },
    changeBorderPosition (position) {
      const index = this.borderPosition.indexOf(position)

      if (position === 'outer') {
        this.borderPosition = ['all']
        return
      }

      if (position !== 'outer') {
        this.borderPosition = this.borderPosition.filter(el => el !== 'all')
      }

      if (index >= 0) {
        this.borderPosition.splice(index, 1)
      } else {
        this.borderPosition.push(position)
      }

      if (!this.borderPosition.length) {
        this.borderPosition = []
      }
    },
    selectBorder (e, border) {
      let borderstyleArray = ['top', 'right', 'bottom', 'left']
      let borderRemoveActive = ['none', 'outer']

      // Add the active class.
      e.currentTarget.classList.toggle('active')

      if (border) {
        this.changeBorderPosition(border.type)
      }

      // If we click on no border or all outer borders
      // We remove active class on top, left, bottom and right borders.
      if (borderRemoveActive.includes(e.currentTarget.id)) {
        for (let i = 0; i < borderstyleArray.length; i++) {
          document.querySelector('.' + borderstyleArray[i]).classList.remove('active')
        }

        if (e.currentTarget.id === 'none') {
          document.querySelector('.outer').classList.remove('active')
        } else {
          document.querySelector('.none').classList.remove('active')
        }
      } else {
        document.querySelector('.none').classList.remove('active')
        document.querySelector('.outer').classList.remove('active')
      }

      if (!this.borderColor) {
        this.borderColor = 'rgba(0,0,0,1)'
      }

      if (this.containerSelected || this.columnselected) {
        if (this.wrapper) {
          this.wrapper.style.borderWidth = this.applyBorderPosition(this.borderPosition, this.bdWidth)
          this.wrapper.style.borderColor = this.borderColor
          this.wrapper.style.borderStyle = 'solid'
        }

        this.syncStateData(this.wrapper)

        if (this.type === 'colonne') {
          this.columnselected = false
          eventBus.$emit('setColumnStyle', {
            style: this.wrapper.style,
            data: this.wrapper,
            colIndex: this.columnIndex,
            containerIndex: this.containerIndex
          })
        } else {
          this.containerSelected = false
          eventBus.$emit('setMyStyle', {
            style: this.wrapper.style,
            wrapper: this.wrapper,
            index: this.wrapperIndex,
            type: this.type
          })
        }
      } else {
        if (this.element.type === 'drop') {
          this.dropStyle[this.context] = []

          if (this.context === 'column') {
            if (typeof this.element.childElements[this.index].colStyle === 'undefined') {
              this.element.childElements[this.index].colStyle = {}
            }

            console.log(this.element.childElements[this.index].colStyle)
            this.element.childElements[this.index].colStyle.borderWidth = this.applyBorderPosition(this.borderPosition, this.bdWidth)
            this.element.childElements[this.index].colStyle.borderColor = this.borderColor
            this.element.childElements[this.index].colStyle.borderStyle = 'solid'

            this.dropStyle[this.context]['borderWidth'] = this.applyBorderPosition(this.borderPosition, this.bdWidth)
            this.dropStyle[this.context]['borderColor'] = this.borderColor
            this.dropStyle[this.context]['borderStyle'] = 'solid'
          }

          if (this.context === 'value') {
            if (typeof this.element.childElements[this.index].valStyle === 'undefined') {
              this.element.childElements[this.index].valStyle = {}
            }

            this.element.childElements[this.index].valStyle.borderWidth = this.applyBorderPosition(this.borderPosition, this.bdWidth)
            this.element.childElements[this.index].valStyle.borderColor = this.borderColor
            this.element.childElements[this.index].valStyle.borderStyle = 'solid'

            this.dropStyle[this.context]['borderWidth'] = this.applyBorderPosition(this.borderPosition, this.bdWidth)
            this.dropStyle[this.context]['borderColor'] = this.borderColor
            this.dropStyle[this.context]['borderStyle'] = 'solid'
          }

          eventBus.$emit('applyBlocContentStyle', {
            data: this.element,
            index: this.index,
            conindex: this.containerIndex,
            colindex: this.columnIndex,
            elindex: this.elindex,
            valueStyle: this.dropStyle,
            context: this.context,
            colStyle: this.element.childElements[this.index].colStyle,
            valStyle: this.element.childElements[this.index].valStyle
          })
        } else {
          this.element.style.borderWidth = this.applyBorderPosition(this.borderPosition, this.bdWidth)
          this.element.style.borderColor = this.borderColor
          this.element.style.borderStyle = 'solid'
        }

        eventBus.$emit('applyStyle', {
          data: this.element,
          conindex: this.containerIndex,
          colindex: this.columnIndex,
          elindex: this.elindex
        })
      }
    },
    setPaddingTop () {
      this.updateStyle('paddingTop', this.paddingTop, 'px')

      // if (this.wrapper) {
      //     this.getAllAppliedStyle()
      // }
    },
    setPaddingBottom () {
      this.updateStyle('paddingBottom', this.paddingBottom, 'px')
      // if (this.wrapper) {
      //     this.getAllAppliedStyle()
      // }
    },
    setPaddingLeft () {
      this.updateStyle('paddingLeft', this.paddingLeft, 'px')
      // if (this.wrapper) {
      //     this.getAllAppliedStyle()
      // }
    },
    setPaddingRight () {
      this.updateStyle('paddingRight', this.paddingRight, 'px')
      // if (this.wrapper) {
      //     this.getAllAppliedStyle()
      // }
    },
    setMarginTop () {
      this.updateStyle('marginTop', this.marginTop, 'px')
      // if (this.wrapper) {
      //     this.getAllAppliedStyle()
      // }
    },
    setMarginBottom () {
      this.updateStyle('marginBottom', this.marginBottom, 'px')
      // if (this.containerSelected) {
      //     this.getAllAppliedStyle()
      // }
    },
    setMarginLeft () {
      this.updateStyle('marginLeft', this.marginLeft, 'px')
      // if (this.wrapper) {
      //     this.getAllAppliedStyle()
      // }
    },
    setMarginRight () {
      this.updateStyle('marginRight', this.marginRight, 'px')
      // if (this.wrapper) {
      //     this.getAllAppliedStyle()
      // }
    },
    getAllAppliedStyle () {
      if (this.element && this.contentSelected) {
        this.updateStyle('borderWidth', this.applyBorderPosition(this.borderPosition, this.bdWidth))
        this.updateStyle('borderColor', this.borderColor)
        this.updateStyle('borderStyle', 'solid')
      } else {
        this.wrapper.style = {
          borderColor: this.borderColor,
          borderWidth: this.applyBorderPosition(this.borderPosition, this.bdWidth),
          borderStyle: 'solid',
          paddingTop: this.paddingTop + 'px',
          paddingRight: this.paddingRight + 'px',
          paddingBottom: this.paddingBottom + 'px',
          paddingLeft: this.paddingLeft + 'px',
          marginTop: this.marginTop + 'px',
          marginRight: this.marginRight + 'px',
          marginBottom: this.marginBottom + 'px',
          marginLeft: this.marginLeft + 'px',
          backgroundColor: this.backgroundColor
        }

        if (this.containerSelected) {
          this.containerSelected = false
          eventBus.$emit('setMyStyle', {
            style: this.wrapper.style,
            wrapper: this.wrapper,
            index: this.wrapperIndex
          })
        }

        if (this.columnselected) {
          this.columnselected = false
          eventBus.$emit('setColumnStyle', {
            style: this.wrapper.style,
            data: this.wrapper,
            colIndex: this.columnIndex,
            containerIndex: this.containerIndex
          })
        }
      }
    },
    setBorderSize (e) {
      if (this.containerSelected || this.columnselected) {
        this.wrapper.style.borderWidth = this.applyBorderPosition(this.borderPosition, this.bdWidth)
        this.wrapper.style.borderColor = this.borderColor
        this.wrapper.style.borderStyle = 'solid'
        // this.syncStateData(this.wrapper)

        // this.containerSelected = false

        if (this.type === 'colonne') {
          // this.columnselected = false
          eventBus.$emit('setColumnStyle', {
            style: this.wrapper.style,
            data: this.wrapper,
            colIndex: this.columnIndex,
            containerIndex: this.containerIndex
          })
        } else {
          eventBus.$emit('setMyStyle', {
            style: this.wrapper.style,
            wrapper: this.wrapper,
            index: this.wrapperIndex
          })
        }
      } else {
        this.element.style.borderWidth = this.applyBorderPosition(this.borderPosition, this.bdWidth)
        this.element.style.borderColor = this.borderColor
        this.element.style.borderStyle = 'solid'

        eventBus.$emit('applyStyle', {
          data: this.element,
          conindex: this.containerIndex,
          colindex: this.columnIndex,
          elindex: this.elindex
        })
      }
    },
    /**
         * Hide items where necessary
         */
    handleClickOutside () {
      this.showBorderColorPicker = false
    },
    handleColumnChange (column) {
      this.context = column
      if (this.context != null) {
        this.syncStateData(this.element)
      }
    },
    handleValueChange (values) {
      this.changedValue = Object.keys(values).map(key => values[key])
    },
    handleDeleteData (data) {
      this.deletedData = data
    },
    getSelectedFontFamily () {
      return this.fontFamily.find(el => el.state === true)
    },
    getSelectedBorderWidth () {
      return this.borderWidth.find(el => el.state === true)
    },
    getSelectedFontSize () {
      if (this.element) {
        if (this.element.type === 'drop' && this.context) {
          if (typeof this.element.style[this.context] !== 'undefined') {
            return this.element.style[this.context].fontSize.replace('px', '')
          }
        } else if (this.element.type === 'text') {
          return this.element.style.fontSize.replace('px', '')
        }
      }
    },
    textAlignClick (type) {
      this.updateStyle('textAlign', type)
    },
    fontSizeSelected (value) {
      this.updateStyle('fontSize', value, 'px')
    },
    fontFamilyClick (value) {
      this.updateStyle('fontFamily', value)
    },
    borderWidthClick (value) {
      this.updateStyle('borderWidth', value)
    },
    fontWeightClick () {
      const state = !this.fontWeight.state
      if (state) {
        this.updateStyle('fontWeight', 'bold')
      } else {
        this.updateStyle('fontWeight', 'normal')
      }
    },
    fontStyleClick () {
      const state = !this.fontStyle.state
      if (state) {
        this.updateStyle('fontStyle', 'italic')
      } else {
        this.updateStyle('fontStyle', 'normal')
      }
    },
    toRgbaString (color) {
      const { r, g, b, a } = color.rgba
      return `rgba(${r}, ${g}, ${b}, ${a})`
    },
    changeColor (color) {
      this.usedFontColor = this.toRgbaString(color)
      this.color = this.toRgbaString(color)
      if (this.element) {
        this.color = this.element.style.color
        this.usedFontColor = this.element.style.color

        if (this.element.type === 'drop') {
          this.color = this.element.style[this.context].color
          this.usedFontColor = this.element.style[this.context].color

          if (typeof this.element.style[this.context] !== 'undefined') {
            this.element.style[this.context].color = this.toRgbaString(color)
          } else {
            this.color = '#000'
          }
        }

        this.element.style.color = this.toRgbaString(color)

        this.updateStyle('color', this.element.style.color)
      }
    },
    changeBorderColor (color) {
      this.usedFontColor = this.toRgbaString(color)
      this.borderColor = this.toRgbaString(color)

      if (this.borderPosition.length > 0) {
        this.updateStyle('borderColor', this.toRgbaString(color))
      }

      // if (this.element.type === 'drop') {
      //     this.element.style[this.context].color = this.toRgbaString(color)
      // }
      // this.element.style.color = this.toRgbaString(color)
    },
    changeBackgroundColor (backgroundColor) {
      // this.usedFontColor = this.toRgbaString(backgroundColor)
      // this.backgroundColor = this.toRgbaString(backgroundColor)

      if (this.columnselected === false && this.containerSelected === false) {
        // this.backgroundColor = this.element.style.backgroundColor
        // this.usedFontColor = this.element.style.backgroundColor

        if (this.element && typeof this.element !== 'undefined' && this.element.type === 'drop') {
          // this.element.style[this.context].backgroundColor = this.toRgbaString(backgroundColor)
          if (this.context === 'column') {
            if (typeof this.element.childElements[this.index].colStyle === 'undefined') {
              this.element.childElements[this.index].colStyle = {}
            }

            this.element.childElements[this.index].colStyle.backgroundColor = this.toRgbaString(backgroundColor)
            this.updateStyle('backgroundColor', this.element.childElements[this.index].colStyle.backgroundColor)

            this.backgroundColor = this.element.childElements[this.index].colStyle.backgroundColor
            this.usedFontColor = this.element.childElements[this.index].colStyle.backgroundColor
          } else {
            if (typeof this.element.childElements[this.index].valStyle === 'undefined') {
              this.element.childElements[this.index].valStyle = {}
            }

            this.element.childElements[this.index].valStyle.backgroundColor = this.toRgbaString(backgroundColor)
            this.updateStyle('backgroundColor', this.element.childElements[this.index].valStyle.backgroundColor)

            this.backgroundColor = this.element.childElements[this.index].valStyle.backgroundColor
            this.usedFontColor = this.element.childElements[this.index].valStyle.backgroundColor
          }
        } else {
          this.element.style.backgroundColor = this.toRgbaString(backgroundColor)

          this.updateStyle('backgroundColor', this.element.style.backgroundColor)
        }
      } else {
        this.updateStyle('backgroundColor', this.toRgbaString(backgroundColor))
      }
    },
    updateStyle (attribut, value, unit = '', skipContext = false) {
      if (this.element && this.context && !skipContext) {
        if (attribut === 'justifyContent') {
          attribut = 'text-align'
        }

        if (attribut === 'fontFamily') {
          attribut = 'font-family'
        }

        this.dropStyle[this.context] = []

        var colStyle = this.element.childElements[this.index].colStyle

        if (typeof colStyle === 'undefined') {
          colStyle = {}
        }

        var valStyle = this.element.childElements[this.index].valStyle

        if (typeof valStyle === 'undefined') {
          valStyle = {}
        }
        // if (typeof this.element.childElements[this.index].style !== 'undefined') {
        //     for (var i in this.element.childElements[this.index].style[this.context]) {
        //         this.dropStyle[this.context][i] = this.element.childElements[this.index].style[this.context]
        //         this.colStyle += '"' + i + '": ' + '"' + this.element.childElements[this.index].style['column'] + '",';
        //         this.valStyle += '"' + i + '": ' + '"' + this.element.childElements[this.index].style['value'] + '",';
        //     }
        // }

        this.dropStyle[this.context][attribut] = `${value}${unit}`

        if (this.context === 'value') {
          valStyle[attribut] = `${value}${unit}`
        }

        if (this.context === 'column') {
          colStyle[attribut] = `${value}${unit}`
        }

        this.contentSelected = false

        eventBus.$emit('applyBlocContentStyle', {
          data: this.element,
          index: this.index,
          conindex: this.containerIndex,
          colindex: this.columnIndex,
          elindex: this.elindex,
          valueStyle: this.dropStyle,
          context: this.context,
          colStyle: colStyle,
          valStyle: valStyle
        })

        return
      }

      if (this.containerSelected === false && this.columnselected === false) {
        this.$set(this.element.style, attribut, `${value}${unit}`)
        this.syncStateData(this.element)
        this.contentSelected = false

        eventBus.$emit('applyStyle', {
          data: this.element,
          conindex: this.containerIndex,
          colindex: this.columnIndex,
          elindex: this.elindex
        })

        return
      }

      if (this.containerSelected || this.columnselected) {
        this.$set(this.wrapper.style, attribut, `${value}${unit}`)
        this.syncStateData(this.wrapper)
        if (this.type === 'colonne') {
          eventBus.$emit('setColumnStyle', {
            style: this.wrapper.style,
            data: this.wrapper,
            colIndex: this.columnIndex,
            containerIndex: this.containerIndex
          })
        } else {
          eventBus.$emit('setMyStyle', {
            style: this.wrapper.style,
            wrapper: this.wrapper,
            index: this.wrapperIndex
          })
        }
      }
    },
    activateBorderButton (theStyle) {
      document.getElementById('top').classList.remove('active')
      document.getElementById('right').classList.remove('active')
      document.getElementById('bottom').classList.remove('active')
      document.getElementById('left').classList.remove('active')
      document.getElementById('outer').classList.remove('active')

      if (theStyle) {
        if (theStyle.borderWidth) {
          var selectedBorders = theStyle.borderWidth.split(' ')

          // Here we test if we have borders on ALL sides.
          if (selectedBorders.length > 0) {
            var allSelected = true
            for (var i = 0; i < selectedBorders.length; i++) {
              if (selectedBorders[i][0] == '0') {
                allSelected = false
                break
              }
            }

            // Do we have borders on all sides?
            if (allSelected) {
              document.getElementById('outer').classList.add('active')

              // We stop here..
              return
            }

            // Activate border top button in toolbar
            if (selectedBorders[0][0] > 0) {
              document.getElementById('top').classList.add('active')
            }

            // Activate border right button in toolbar
            if (selectedBorders[1][0] > 0) {
              document.getElementById('right').classList.add('active')
            }

            // Activate border bottom button in toolbar
            if (selectedBorders[2][0] > 0) {
              document.getElementById('bottom').classList.add('active')
            }

            // Activate border left button in toolbar
            if (selectedBorders[3][0] > 0) {
              document.getElementById('left').classList.add('active')
            }
          }
        }
      }
    },
    syncStateData (newValue) {
      if (this.element && this.element.type === 'drop' && this.context) {
        var theStyle
        if (this.index in this.element.childElements) {
          if (this.context === 'column') {
            theStyle = this.element.childElements[this.index].colStyle
          } else {
            theStyle = this.element.childElements[this.index].valStyle
          }
        }

        this.marginTop = typeof theStyle !== 'undefined' && theStyle.marginTop
          ? theStyle.marginTop.replace('px', '')
          : 0
        this.marginBottom = typeof theStyle !== 'undefined' && theStyle.marginBottom
          ? theStyle.marginBottom.replace('px', '')
          : 0
        this.marginRight = typeof theStyle !== 'undefined' && theStyle.marginRight
          ? theStyle.marginRight.replace('px', '')
          : 0
        this.marginLeft = typeof theStyle !== 'undefined' && theStyle.marginLeft
          ? theStyle.marginLeft.replace('px', '')
          : 0

        this.paddingTop = typeof theStyle !== 'undefined' && theStyle.paddingTop
          ? theStyle.paddingTop.replace('px', '')
          : 0
        this.paddingBottom = typeof theStyle !== 'undefined' && theStyle.paddingBottom
          ? theStyle.paddingBottom.replace('px', '')
          : 0
        this.paddingRight = typeof theStyle !== 'undefined' && theStyle.paddingRight
          ? theStyle.paddingRight.replace('px', '')
          : 0
        this.paddingLeft = typeof theStyle !== 'undefined' && theStyle.paddingLeft
          ? theStyle.paddingLeft.replace('px', '')
          : 0

        this.justifyContent.forEach(el => {
          if (theStyle && theStyle['text-align'] === el.type) {
            el.state = true
            return
          }
          el.state = false
        })

        this.fontSize.forEach(el => {
          if (typeof theStyle !== 'undefined' && theStyle.fontSize && theStyle.fontSize.replace('px', '') === el.value) {
            el.state = true
            return
          }
          el.state = false
        })

        if (typeof theStyle !== 'undefined') {
          for (var i = 0; i < this.fontFamily.length; i++) {
            if (typeof this.fontFamily[i] !== 'undefined' &&
                            typeof theStyle['font-family'] !== 'undefined' &&
                            theStyle['font-family'] === this.fontFamily[i].family) {

              // this.fontFamily[i].state = true
            } else {
              // this.fontFamily[i].state = false
            }
          }
        }

        this.activateBorderButton(theStyle)
        // this.fontFamily.forEach(el => {
        //     if (typeof theStyle !== 'undefined' && typeof el !== 'undefined' && typeof theStyle['font-family'] !== 'undefined' && theStyle['font-family'] === el.family) {
        //         el.state = true
        //         return
        //     }
        //     el.state = false
        // })

        let bdWidth = 0

        if (theStyle) {
          this.fontStyle.state = theStyle.fontStyle === this.fontStyle.name
          this.fontWeight.state = theStyle.fontWeight === this.fontWeight.name

          if (theStyle.borderWidth) {
            let split = theStyle.borderWidth.split(' ')
            bdWidth = split[0].replace('px', '')
          }
        }

        this.borderColor = typeof theStyle !== 'undefined' && theStyle.borderColor ? theStyle.borderColor : ''
        this.bdWidth = bdWidth
        this.color = typeof theStyle !== 'undefined' && theStyle.color ? theStyle.color : 'rgba(0,0,0,1)'
        this.backgroundColor = typeof theStyle !== 'undefined' && theStyle.backgroundColor ? theStyle.backgroundColor : 'rgba(255,255,255,1)'
        return
      }

      if (this.wrapper && this.wrapper.style) {
        this.paddingTop = this.wrapper.style.paddingTop
          ? this.wrapper.style.paddingTop.replace('px', '')
          : 0
        this.paddingRight = this.wrapper.style.paddingRight
          ? this.wrapper.style.paddingRight.replace('px', '')
          : 0
        this.paddingBottom = this.wrapper.style.paddingBottom
          ? this.wrapper.style.paddingBottom.replace('px', '')
          : 0
        this.paddingLeft = this.wrapper.style.paddingLeft
          ? this.wrapper.style.paddingLeft.replace('px', '')
          : 0
        this.marginTop = this.wrapper.style.marginTop
          ? this.wrapper.style.marginTop.replace('px', '')
          : 0
        this.marginBottom = this.wrapper.style.marginBottom
          ? this.wrapper.style.marginBottom.replace('px', '')
          : 0

        this.marginRight = this.wrapper.style.marginRight
          ? this.wrapper.style.marginRight.replace('px', '')
          : 0

        this.marginLeft = this.wrapper.style.marginLeft
          ? this.wrapper.style.marginLeft.replace('px', '')
          : 0

        this.backgroundColor = this.wrapper.style.backgroundColor ? this.wrapper.style.backgroundColor : this.backgroundColor

        this.borderColor = this.wrapper.style.borderColor ? this.wrapper.style.borderColor : ''

        let bdWidth = 0
        if (this.wrapper.style.borderWidth) {
          let split = this.wrapper.style.borderWidth.split(' ')
          bdWidth = split[0].replace('px', '')
        }

        this.bdWidth = bdWidth

        this.activateBorderButton(this.wrapper.style)

        return
      }

      if (this.element) {
        this.paddingTop = this.element.style.paddingTop
          ? this.element.style.paddingTop.replace('px', '')
          : 0
        this.paddingRight = this.element.style.paddingRight
          ? this.element.style.paddingRight.replace('px', '')
          : 0
        this.paddingBottom = this.element.style.paddingBottom
          ? this.element.style.paddingBottom.replace('px', '')
          : 0
        this.paddingLeft = this.element.style.paddingLeft
          ? this.element.style.paddingLeft.replace('px', '')
          : 0
        this.marginTop = this.element.style.marginTop
          ? this.element.style.marginTop.replace('px', '')
          : 0
        this.marginBottom = this.element.style.marginBottom
          ? this.element.style.marginBottom.replace('px', '')
          : 0

        this.marginRight = this.element.style.marginRight
          ? this.element.style.marginRight.replace('px', '')
          : 0

        this.marginLeft = this.element.style.marginLeft
          ? this.element.style.marginLeft.replace('px', '')
          : 0

        this.justifyContent.forEach(el => {
          if (this.element.style.textAlign === el.type) {
            el.state = true
            return
          }
          el.state = false
        })
        this.backgroundColor = this.element.style.backgroundColor ? this.element.style.backgroundColor : this.backgroundColor
        // this.fontSize.forEach(el => {
        //     if (typeof this.element.style.fontSize !== 'undefined' && this.element.style.fontSize.replace('px', '') === el.value) {
        //         el.state = true
        //         return
        //     }
        //     el.state = false
        // })
        // this.fontFamily.forEach(el => {
        //     if (typeof this.element.style.fontFamily !== 'undefined' && this.element.style.fontFamily === el.family) {
        //         el.state = true
        //         return
        //     }
        //     el.state = false
        // })
        this.fontStyle.state = this.element.style.fontStyle === this.fontStyle.name
        this.fontWeight.state = this.element.style.fontWeight === this.fontWeight.name
        this.color = this.element.style.color
        this.borderColor = this.element.style.borderColor ? this.element.style.borderColor : ''

        let bdWidth = 0
        if (this.element.style.borderWidth) {
          let split = this.element.style.borderWidth.split(' ')
          bdWidth = split[0].replace('px', '')
        }

        this.bdWidth = bdWidth

        this.activateBorderButton(this.element.style)
      }
    },
    handleDropEdit (data) {
      this.element.childElements = data
    },
    handleTextEdit (value) {
      this.element.value = value
    },
    close () {
      this.$refs['editElementModal'].hide()
      this.active = false
    },
    saveChanges () {
      if (!this.isProjectTemplate()) {
        this.changedValue.forEach(el => {
          this.syncDataValue(el)
        })
        this.addDeletedHeader(this.deletedData)
      }
      this.setAddedToFiche({headerKey: this.deletedData, value: false})
      this.$emit('elementUpdate', this.element)
      this.close()
    },
    open (data) {
      this.element = JSON.parse(JSON.stringify(data.element))
      if (data.element.type === 'text') {
        this.syncStateData(this.element)
      }
      if (data.elindex || data.elindex === 0) {
        this.elindex = data.elindex
      }
      this.active = true
      this.$nextTick().then(() => {
        this.$refs['editElementModal'].show()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
    .btn-toolbar{
        .btn-group[role="group"]{
            margin: 0 5px;
        }
    }

    .slide-fade-enter-active {
        transition: all .2s ease;
    }
    .slide-fade-leave-active {
        transition: all .15s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */ {
        transform: translateX(10px);
        opacity: 0;
    }

    .content-editor{
        border-right: 1px solid #dee2e6;
    }

    .disabled-action {
        position: relative;
        cursor: not-allowed;
        &:before {
            content: "";
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            background-color: transparent;
            z-index: 100;
        }
        .btn-group.b-dropdown {
            color: #6c757d !important;
            border-color: #6c757d !important;
        }
        button {
            color: #6c757d;
            border-color: #6c757d;
            &.active {
                background-color: #6c757d !important;
            }
        }
    }
    ul {
        list-style: none;
        padding-left: 0;
        &.wrapper-setting {
            margin: 0;
            float: left;
            width: 100%;
            background-color: #ffffff;
        }
        .setting-option {
            border-bottom: 1px solid #ddd;
            float: left;
            display: inline-block;
            width: 95%;
            padding: 15px 2.5%;
            margin: 0;
            .option-details {
                width: 100%;
                float: left;
                display: inline-block;
                .description {
                    color: #999;
                    margin-bottom: 1em;
                    font-size: 12px;
                    font-style: italic;
                }
                h3 {
                    font-size: 18px;
                }
            }
            .option-field {
                width: 100%;
                float: left;
                padding: 1.1em 0 0 10%;
                .multi-input{
                    // display: inline-flex;
                    input{
                        margin-right: 10%;
                    }
                }
                .picker-wrapper{
                    display: inline-block;
                    .color-picker{
                        .hu-color-picker{
                            box-sizing: content-box;
                            z-index: 99999;
                        }
                    }
                    .picker-value {
                        min-height: 31px;
                        border-radius: 0 !important;
                        box-shadow: none !important;
                        margin:0 6px 6px 0;
                        padding: 0 0 0 30px;
                        font-size: 11px;
                        border: 1px solid #ccc;
                        .picker-text{
                            height: 100%;
                            line-height: 30px;
                            background-color: #f7f7f7;
                            border-left: 1px solid #ccc;
                            color: #555;
                            display: block;
                            padding: 0 6px;
                            text-align: center;
                        }
                    }
                }
            }
        }
    }
    .hu-color-picker{
        box-sizing: content-box;
        z-index: 99999;
    }
    .dropdown-menu {
        padding-top: 0;
        padding-bottom: 0;
    }
    .hu-color-picker{
        box-sizing: content-box;
    }

    .spacing {
        margin-bottom:5px;
    }

    .borders {
        border-bottom:1px solid #dee2e6;
    }
    .borders li, .spacing li {
        display:inline-block;
        margin-right: 3px;
    }

    .borders li span {
        display:flex;
        cursor:pointer;
    }

    .borders li.active {
        border:1px solid #2b3085;
    }

    .input-group-append .input-group-text {
        background:none;
        padding: 0 4px;
        font-size: 10px;
        border-left:none !important;
    }

    .input-group-prepend {
        background:none;
    }

    .borders .input-group input {
        border:1px solid #2b3085 !important;
        border-right:none !important;
        text-align:center;
    }

    .spacing .input-group input{
        border:1px solid #2b3085 !important;
        text-align:center;
    }
    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        margin: 0;
    }
    .disabled-action {
        position: relative;
        cursor: not-allowed;
        &:before {
            content: "";
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            background-color: transparent;
            z-index: 100;
        }
        .btn-group.b-dropdown {
            color: #6c757d !important;
            border-color: #6c757d !important;
        }
        button {
            color: #6c757d;
            border-color: #6c757d;
            &.active {
                background-color: #6c757d !important;
            }
        }
    }
    .input-group-text {
        border:1px solid #2b3085;
        background:none;
    }
    .input-group-text svg {
        color: #2b3085;
    }
    .input-group {

    }

    .px  {
        color:#2b3085;
        font-weight:bold;
    }

    .myBgColor path {
        fill: var(--bgImage);
    }

    .enlarge {
        max-width: 30% !important;
        flex: 0 0 26%;
    }

    .background-color-picker ul {
        z-index: 9999;
    }

    #padding-and-margin {
        flex: 0 0 38% !important;
        border-right: none;
        max-width: 37% !important;
        padding-right: 0 !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/edit/rightToolbar.vue